var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79045 12.5513C9.10817 11.9325 8.69287 11.0916 8.69287 10.1482C8.69287 8.25825 10.3683 6.73486 12.4472 6.73486C13.4759 6.73486 14.4228 7.11329 15.0932 7.73213",
    stroke: "#909090",
    strokeWidth: 2.15821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1314 10.7534C15.8561 12.1442 14.6506 13.2417 13.1211 13.494",
    stroke: "#909090",
    strokeWidth: 2.15821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10498 15.9002C4.2219 14.5569 2.62715 12.5947 1.47144 10.1485C2.63902 7.6914 4.24444 5.71843 6.13939 4.36431C8.02247 3.01018 10.1951 2.2749 12.4472 2.2749C14.7123 2.2749 16.8838 3.02096 18.7787 4.38479",
    stroke: "#909090",
    strokeWidth: 2.15821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2843 6.75586C22.1007 7.74127 22.8186 8.87869 23.4225 10.1476C21.0885 15.0607 16.964 18.0201 12.4468 18.0201C11.4228 18.0201 10.413 17.8692 9.44238 17.5748",
    stroke: "#909090",
    strokeWidth: 2.15821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8063 1.64404L3.08936 18.6504",
    stroke: "#909090",
    strokeWidth: 2.15821,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.5f468d8159e9ce821f1f07a327617b4f.svg";
export { ForwardRef as ReactComponent };